import React, { useEffect, useState } from 'react';
import Form from 'react-jsonschema-form';

const schema = {
  type: 'object',
  properties: {
    no: { type: 'number' },
    fonction: { type: 'string', enum: ['Telecommande', 'Camera'] },
  },
};

const uiSchema = {
  no: { 'ui:autofocus': true, 'ui:emptyValue': '' },
  'ui:title': 'Modifier le client',
};

const DeviceFormAdd = (props) => {
  function handleSubmit({ formData }) {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/devices/', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then(() => {
        if (props.hasCommit) {
          props.hasCommit(true);
        }
      });
  }

  function log() {}

  return <Form schema={schema} uiSchema={uiSchema} onSubmit={handleSubmit} onError={log} />;
};

const DeviceFormUpdate = (props) => {
  const [device, setDevice] = useState({ ...(props.formData || {}) });

  useEffect(() => {
    setDevice({ ...(props.formData || {}) });
  }, [props.formData]);

  function handleSubmit() {
    const appareilId = props.location && props.location.state && props.location.state.appareil ? props.location.state.appareil._id : props.dbid;
    if (!appareilId) {
      return;
    }
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/devices/' + appareilId, {
      method: 'PUT',
      body: JSON.stringify(device),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function log() {}

  return <Form schema={schema} uiSchema={uiSchema} formData={device} onSubmit={handleSubmit} onError={log} />;
};

export { DeviceFormAdd, DeviceFormUpdate };



// WEBPACK FOOTER //
// src/components/devices/DeviceForm.js